module.exports = __webpack_public_path__ + "img/jx4.a1838c6e.png";